import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preset"];
import React from "react";
import * as Presets from "./Presets";
import PrimitiveSkeletonBox from "./primitives";
import { jsx as _jsx } from "react/jsx-runtime";
function SkeletonBox(_ref) {
  var preset = _ref.preset,
    props = _objectWithoutProperties(_ref, _excluded);
  var SkeletonComponent = preset ? Presets[preset] : PrimitiveSkeletonBox;
  return /*#__PURE__*/_jsx(SkeletonComponent, _extends({}, props));
}
export default SkeletonBox;